// Fail closed: the captcha is only disabled with an explicit NEXT_PUBLIC_ENABLE_CAPCHTA=false,
// a missing or mistyped value keeps it enabled
const isCaptchaEnabled = process.env.NEXT_PUBLIC_ENABLE_CAPCHTA !== 'false';

export default isCaptchaEnabled;
